import axios from "axios";
import { UPDATE_PROFILE_FROM_RESUME_ROUTE } from "./apiRoutes";

const updateProfileFromResume = (data, onProgress) => {
  const formData = new FormData();
  formData.append("user_slug", data.user_slug);
  formData.append("file", data.file);

  return axios.post(UPDATE_PROFILE_FROM_RESUME_ROUTE, formData, {
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        onProgress(percent);
      }
    },
  });
};

export default updateProfileFromResume;
